/**
 * Stories implemented by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent, MouseEventHandler } from 'react';
import { IconChevronDownFilled, IconChevronUpFilled } from '@zillow/constellation-icons';
import { Icon, VisuallyHidden } from '@zillow/constellation-10';
import { DropdownTriggerButton } from './components/DropdownTriggerButton';

export type MobileDropdownMenuSectionDropdownTriggerProps = {
    ariaLabel: string;
    isExpanded: boolean;
    onClick: MouseEventHandler<HTMLButtonElement>;
};

export const MobileDropdownMenuSectionDropdownTrigger: FunctionComponent<
    MobileDropdownMenuSectionDropdownTriggerProps
> = ({ ariaLabel, onClick, isExpanded, ...rest }) => (
    <DropdownTriggerButton {...rest} onClick={onClick} type="button" aria-label={ariaLabel}>
        <VisuallyHidden>{ariaLabel}</VisuallyHidden>
        {isExpanded ? (
            <Icon size="sm" render={<IconChevronUpFilled />} />
        ) : (
            <Icon size="sm" render={<IconChevronDownFilled />} />
        )}
    </DropdownTriggerButton>
);
